// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3yf11","footer":"ChangeClinic_footer__jzf_s"};